export class FAQ {
    constructor() {
        $('.js-toggle-faq').click((e) => this.toggle(e));
    }

    toggle(e) {
        $(e.currentTarget).next('div').slideToggle(200);
    }
}